import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { BlogForm, BlogFormData } from "../form/BlogForm";
import { useBlogToast, useBlogRegistration } from "../../pages/blogs/hook";
import { Toast } from "../../atoms/Toast";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: BlogFormData) => void;
  refetchBlogs?: () => void;
};

export const CreateBlogModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  refetchBlogs
}) => {
  const { toast, showToast, hideToast } = useBlogToast();
  const { handleRegisterBlog } = useBlogRegistration(showToast, refetchBlogs, onClose);

  const handleFormSubmit = async (
    data: BlogFormData,
    onError: (message: string) => void
  ): Promise<void> => {

    return new Promise<void>((resolve, reject) => {

      handleRegisterBlog(
        {
          title: data.title,
          content: data.content,
          author_name: data.author_name || "",
          publish: data.publish,
          image: data.image,
        },
        (errorMessage) => {
          onError(errorMessage);
          reject(new Error(errorMessage));
        },
        () => {
          onSubmit?.(data);
          resolve();
        }
      );
    });
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Create Blog"
        onClose={onClose}
      >
        <BlogForm key={isOpen ? 'open' : 'closed'} handleSubmit={handleFormSubmit} />
      </ModalTemplate>
    </div>
  );
};
